<template>
  <div class="app-container">
    <h1>作业批改</h1>

    <!-- 顶部统计和创建按钮 -->
    <div class="header-bar">
      <span class="total-count">共{{ totalHomeworks }}道题</span>
      <div class="buttons-group">
        <button class="create-btn" @click="showCreateDialog">
          + 创建作业
        </button>
        <button class="image-create-btn" @click="showImageHomeworkCreator">
          + 自建作业
        </button>
      </div>
      <!-- <el-button type="primary" @click="testuser">测试id查询用户</el-button> -->
      <!-- <el-button type="primary" @click="test">测试按钮</el-button> -->
    </div>

    <!-- 作业列表 -->
    <table class="homework-table">
      <thead>
        <tr>
          <th>作业名称</th>
          <th>创建时间</th>
          <th>创建人</th>
          <th>发布班级</th>
          <th>发布状态</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody v-loading="loading">
        <tr v-for="(homework) in homeworkList" :key="homework.id">
          <td><span class="view-btn" @click="handleHomeworkNameClick(homework)">{{ homework.name }}</span></td>
          <td>{{ homework.createTime }}</td>
          <td>{{ homework.createPerson }}</td>
          <td>{{ getPublishedClasses(homework) }}</td>
          <td>{{ homework.publishStatus || (homework.published ? '已发布' : '未发布') }}</td>
          <td class="action-column">
            <span class="edit-btn" @click="editHomework(homework)">编辑</span>
            <span class="publish-btn" @click="publishHomework(homework.id)">
              {{ homework.published ? '重新发布' : '发布' }}
            </span>
            <span class="delete-btn" @click="deleteHomework(homework.id)">删除</span>
            <span class="batch-upload-btn" @click="openBatchUpload(homework)">批量上传</span>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- 编辑作业对话框 -->
    <el-dialog title="作业编辑器" :visible.sync="editDialogVisible" width="80%" :before-close="handleClose">
      <div class="homework-editor">
        <div class="editor-container">
          <div class="editor-left">
            <h3>题目列表</h3>
            <!-- 添加OCR识别按钮和手动输入按钮 -->
            <div class="knowledge-select">
              <el-button type="primary" size="small" @click="showOcrDialog" style="margin-right: 10px;">
                OCR识别题目
              </el-button>
              <el-button type="primary" size="small" @click="showInputDialog" style="margin-right: 10px;">
                手动输入题目
              </el-button>
              <el-cascader
                v-model="selectedKnowledgePath"
                placeholder="请选择知识点"
                clearable
                filterable
                :options="knowledgePoints"
                :props="knowledgeCascaderProps"
                style="width: 200px; margin-right: 10px"
                @change="handleKnowledgeChange"
              />
              <el-select v-model="selectedRepoId" placeholder="请选择题库" style="width: 200px; margin-right: 10px">
                <el-option v-for="item in repoList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
              <el-button type="primary" size="small" @click="searchQuestions">查询</el-button>
              <el-button size="small" @click="resetQuestions" style="margin-left: 8px;">重置</el-button>
            </div>

            <!-- 题目列表区域 -->
            <div class="question-list" v-loading="questionsLoading">
              <div v-if="showEmptyState" class="empty-state">
                <p>目前还没有创建题目</p>
                <p>您可以点击上方的"手动输入题目"或"OCR识别题目"来添加题目</p>
              </div>
              <div v-else class="question-items">
                <el-checkbox-group v-model="selectedQuestions">
                  <div v-for="question in sortedQuestionList" :key="question.id" class="question-item">
                    <el-checkbox :label="question.id">
                      <div class="question-content">
                        <div class="question-title" v-html="renderMathFormula(question.content || '-')" style="line-height: 1.6;"></div>
                        <div class="question-info">
                          <span>题型：{{ getQuestionType(question.quType) }}</span>
                          <span>章节：{{ question.chapter || '-' }}</span>
                          <span>创建时间：{{ question.createTime || '-' }}</span>
                        </div>
                      </div>
                    </el-checkbox>
                  </div>
                </el-checkbox-group>
              </div>
            </div>

            <!-- 底部操作按钮 -->
            <div class="question-actions" v-if="selectedQuestions.length > 0">
              <el-button type="primary" size="small" @click="addSelectedQuestions">
                添加选中题目 ({{ selectedQuestions.length }})
              </el-button>
            </div>
          </div>
          <div class="editor-right">
            <h3>作业预览</h3>
            <div class="preview-area">
              <div v-if="!currentHomework.questions || currentHomework.questions.length === 0" class="empty-state">
                <p>暂无题目</p>
                <p>请从左侧选择题目添加</p>
              </div>
              <div v-else class="preview-questions">
                <div v-for="(question, index) in currentHomework.questions" :key="question.id"
                  class="preview-question-item">
                  <div class="question-header">
                    <span class="question-number">第{{ index + 1 }}题</span>
                    <el-button type="text" class="delete-btn" @click="removeQuestion(index)">
                      删除
                    </el-button>
                  </div>
                  <div class="question-body">
                    <div class="question-content" v-html="renderMathFormula(question.content)" style="line-height: 1.6;"></div>
                    <div class="question-info">
                      <span>题型：{{ getQuestionType(question.quType) }}</span>
                      <span>分数：{{(question.point) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 题型统计和总分栏 -->
            <div class="question-summary-bar" v-if="currentHomework.questions && currentHomework.questions.length">
              <div style="display: flex; justify-content: space-between; align-items: center; padding: 12px 0; border-top: 1px solid #e4e7ed; margin-top: 10px;">
                <div>
                  <span v-for="(count, type) in questionTypeCount" :key="type" style="margin-right: 18px;">
                    {{ getQuestionType(type) }}：{{ count }}道
                  </span>
                </div>
                <div>
                  总分：{{ totalPoints }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveHomework">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 学生列表弹窗 -->
    <el-dialog :title="`学生提交列表 - ${currentHomework.submissionCount || 0}/${currentHomework.totalStudents || 0}`" :visible.sync="studentListVisible" width="80%">
      <!-- 班级标签选择器 -->
      <div class="class-tags-container" v-if="currentHomework.gradeIds && currentHomework.gradeIds.length > 0">
        <div class="class-tags-header">
          <span class="tags-label">发布班级：</span>
          <el-tag
            v-for="classId in currentHomework.gradeIds"
            :key="classId"
            :type="selectedClassId === classId ? 'primary' : 'info'"
            :effect="selectedClassId === classId ? 'dark' : 'plain'"
            class="class-tag"
            @click="selectClass(classId)"
            style="cursor: pointer; margin-right: 10px; margin-bottom: 10px;"
          >
            {{ getClassName(classId) }}
            <span class="submission-count">({{ getClassSubmissionCount(classId) }})</span>
          </el-tag>
        </div>
      </div>

      <!-- 添加统计信息卡片 -->
      <div class="stats-cards" v-if="Object.keys(homeworkStats).length > 0">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-card class="stats-card">
              <div class="stats-card-content">
                <div class="stats-card-title">完成率</div>
                <div class="stats-card-value">{{ homeworkStats.completionRate }}%</div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card class="stats-card">
              <div class="stats-card-content">
                <div class="stats-card-title">平均分</div>
                <div class="stats-card-value">{{ homeworkStats.averageScore }}</div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card class="stats-card">
              <div class="stats-card-content">
                <div class="stats-card-title">分数分布</div>
                <div class="score-distribution-mini">
                  <div v-for="(count, range) in homeworkStats.scoreDistribution" :key="range" class="distribution-item-mini">
                    <span class="range-label-mini">{{ range }}:</span>
                    <span class="count-value">{{ count }}人</span>
                  </div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>

      <!-- 学生列表 -->
      <el-table :data="filteredStudents" border style="width: 100%">
        <el-table-column prop="username" label="学生姓名">
          <template slot-scope="scope">
            <span class="student-name" @click="showCorrectionResult(scope.row)">{{ scope.row.username }}</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="studentListVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 批改结果弹窗 -->
    <el-dialog title="作业批改结果" :visible.sync="correctionResultVisible" width="80%">
      <div class="correction-dialog-body-beauty">
        <div class="correction-image-beauty">
          <img
            v-if="studentImageUrl"
            :src="studentImageUrl"
            alt="作业图片"
            :style="{
              maxWidth: '100%',
              maxHeight: '700px',
              borderRadius: '12px',
              boxShadow: '0 2px 12px rgba(0,0,0,0.12)',
              background: '#fff',
              padding: '12px',
              cursor: dragging ? 'grabbing' : 'grab',
              transform: `scale(${imageScale}) translate(${imageOffset.x}px, ${imageOffset.y}px)`,
              transition: dragging ? 'none' : 'transform 0.2s',
              position: dragging ? 'absolute' : 'static',
              zIndex: dragging ? 10 : 'auto',
              left: 0,
              top: 0
            }"
            @wheel.prevent="handleImageWheel"
            @mousedown="startDrag"
          />
          <div v-else class="no-image">暂无图片</div>
          <div class="zoom-tip">滚轮缩放，拖拽图片</div>
          <!-- 添加图片切换控制 -->
          <div class="image-navigation" v-if="studentSubmissions.length > 1">
            <el-button
              :disabled="currentImageIndex === 0"
              @click="prevImage"
              icon="el-icon-arrow-left"
            >上一张</el-button>
            <span class="image-counter">{{ currentImageIndex + 1 }}/{{ studentSubmissions.length }}</span>
            <el-button
              :disabled="currentImageIndex === studentSubmissions.length - 1"
              @click="nextImage"
              icon="el-icon-arrow-right"
            >下一张</el-button>
          </div>
        </div>
        <div class="correction-table-beauty">
          <div class="student-info" v-if="currentStudent">
            <h3>学生：{{ currentStudent.username }} <span v-if="currentStudentScore !== null">- 得分: {{ currentStudentScore }}</span></h3>
          </div>
          <el-table :data="correctionResults" border style="width: 100%">
            <el-table-column label="序号" type="index" width="60" align="center" />
            <el-table-column prop="stem" label="题目" min-width="400">
              <template slot-scope="scope">
                {{ scope.row.stem }}
              </template>
            </el-table-column>
            <el-table-column prop="point" label="分数" width="100" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.point" size="small" placeholder="请输入分数" type="number" min="0" style="width: 80px;" />
              </template>
            </el-table-column>
            <el-table-column prop="judge" label="结果" width="150" align="center">
              <template slot-scope="scope">
                <el-dropdown @command="val => handleJudgeChange(scope.$index, val)">
                  <el-tag
                    :type="scope.row.judge === 'right' ? 'success' : (scope.row.judge === 'error' ? 'danger' : 'info')"
                    style="cursor:pointer"
                  >
                    <template v-if="scope.row.judge === 'right'">正确</template>
                    <template v-else-if="scope.row.judge === 'error'">错误</template>
                    <template v-else>未批改</template>
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-tag>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="right">
                      <el-tag type="success">正确</el-tag>
                    </el-dropdown-item>
                    <el-dropdown-item command="error">
                      <el-tag type="danger">错误</el-tag>
                    </el-dropdown-item>
                    <el-dropdown-item command="未批改">
                      <el-tag type="info">未批改</el-tag>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
            <el-table-column prop="comment" label="评语" min-width="200">
              <template slot-scope="scope">
                <el-input v-model="scope.row.comment" placeholder="请输入评语" size="small" />
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" style="display: flex; flex-direction: column; align-items: center;">
        <div style="margin-bottom: 15px;">
          <el-checkbox v-model="autoAddToWrongBook" style="margin-right: 20px;">
            自动将错误题目添加到学生错题本
          </el-checkbox>
          <span v-if="autoAddToWrongBook && errorQuestionCount > 0" style="color: #E6A23C; font-size: 12px;">
            (将添加 {{ errorQuestionCount }} 道错误题目)
          </span>
        </div>
        <div>
          <el-button :disabled="currentPage === 1" @click="prevPage">上一页</el-button>
          <span style="margin: 0 15px;">第{{ currentPage }}/{{ totalPages }}页</span>
          <el-button :disabled="currentPage === totalPages" @click="nextPage">下一页</el-button>
        </div>
        <div style="margin-bottom: 20px;">
          <el-button @click="correctionResultVisible = false">关 闭</el-button>
          <el-button type="primary" @click="saveCorrectionResults">保存</el-button>
        </div>
      </span>
    </el-dialog>

    <!-- 学生作业图片 -->
    <el-dialog
      title="学生作业图片"
      :visible.sync="studentImageDialogVisible"
      width="40%"
    >
      <img v-if="studentImageUrl" :src="studentImageUrl" alt="作业图片" style="max-width:100%;display:block;margin:auto;" />
      <div v-else>暂无图片</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="studentImageDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- OCR识别对话框 -->
    <el-dialog
      title="OCR识别题目"
      :visible.sync="ocrDialogVisible"
      width="30%"
      :before-close="handleOcrDialogClose"
    >
      <div class="upload-container">
        <div style="margin-bottom: 10px; font-weight: 600;">题目图片</div>
        <!-- <div class="question-type-select">
          <span class="label">请选择题目类型：</span>
          <el-radio-group v-model="selectedQuType">
            <el-radio v-for="item in quTypeOptions" :key="item.value" :label="item.value">
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </div> -->
        <el-upload
          class="upload-demo"
          drag
          action="#"
          :auto-upload="false"
          multiple
          :on-change="handleFileChange"
          :on-remove="handleFileRemove"
          :file-list="fileList"
          accept="image/*"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em>（可多选）</div>
          <div class="el-upload__tip" slot="tip">支持多张图片，建议jpg/png</div>
        </el-upload>

        <div style="margin: 20px 0 10px; font-weight: 600;">参考答案图片（可选）</div>
        <el-upload
          class="upload-demo"
          drag
          action="#"
          :auto-upload="false"
          :on-change="handleAnswersFileChange"
          :on-remove="handleAnswersFileRemove"
          :file-list="answersFileList"
          accept="image/*"
          :limit="1"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">拖拽或点击选择参考答案图片（1张，可不选）</div>
          <div class="el-upload__tip" slot="tip">不提供则传递参数 answers=null</div>
        </el-upload>
      </div>
      <div class="dialog-footer" slot="footer">
        <el-button @click="ocrDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleImageUpload">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 手动输入题目对话框 -->
    <el-dialog
      title="手动输入题目"
      :visible.sync="inputDialogVisible"
      width="50%"
    >
      <el-form :model="inputQuestionForm" label-width="100px">
        <el-form-item label="题目类型">
          <el-select v-model="inputQuestionForm.quType" placeholder="请选择题目类型">
            <el-option
              v-for="item in quTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="题目内容">
          <el-input
            type="textarea"
            v-model="inputQuestionForm.content"
            :rows="4"
            placeholder="请输入题目内容"
          />
        </el-form-item>
        <el-form-item label="答案">
          <el-input
            type="textarea"
            v-model="inputQuestionForm.answer"
            :rows="2"
            placeholder="请输入答案"
          />
        </el-form-item>
        <el-form-item label="选项" v-if="inputQuestionForm.quType === 1">
          <el-input
            type="textarea"
            v-model="inputQuestionForm.options"
            :rows="3"
            placeholder="请输入选项，格式：A.选项1;B.选项2;C.选项3;D.选项4"
          />
        </el-form-item>
        <el-form-item label="知识点">
          <el-input
            v-model="inputQuestionForm.knowledge"
            placeholder="请输入知识点"
          />
        </el-form-item>
        <el-form-item label="解析">
          <el-input
            type="textarea"
            v-model="inputQuestionForm.analysis"
            :rows="2"
            placeholder="请输入解析"
          />
        </el-form-item>
        <el-form-item label="评价">
          <el-input
            type="textarea"
            v-model="inputQuestionForm.evaluate"
            :rows="2"
            placeholder="请输入题目评价"
          />
        </el-form-item>
        <el-form-item label="难度">
          <el-slider
            v-model="inputQuestionForm.difficulty"
            :min="0"
            :max="1"
            :step="0.1"
            show-input
            :format-tooltip="formatDifficulty"
          />
        </el-form-item>
        <el-form-item label="等级">
          <el-input-number
            v-model="inputQuestionForm.level"
            :min="1"
            :max="5"
            placeholder="题目等级"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="inputDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleInputQuestion">添 加</el-button>
      </span>
    </el-dialog>

    <!-- 新建作业对话框 -->
    <el-dialog
      title="新建作业"
      :visible.sync="createDialogVisible"
      width="30%"
    >
      <el-form :model="newHomeworkForm" label-width="80px">
        <el-form-item label="作业名称">
          <el-input v-model="newHomeworkForm.name" placeholder="请输入作业名称" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleCreateHomework">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 自建作业组件 -->
    <ImageHomeworkCreator
      ref="imageHomeworkCreator"
      :visible.sync="imageHomeworkCreatorVisible"
      @success="handleImageHomeworkCreated"
    />

    <!-- 批量上传对话框 -->
    <el-dialog
      title="批量上传作业"
      :visible.sync="batchUploadVisible"
      width="50%"
    >
      <div class="upload-container">
        <div class="question-type-select">
          <span class="label">请选择题目类型：</span>
          <el-radio-group v-model="selectedQuType">
            <el-radio v-for="item in quTypeOptions" :key="item.value" :label="item.value">
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </div>
        <el-upload
          class="upload-demo"
          drag
          action="#"
          :auto-upload="false"
          :on-change="handleBatchFileChange"
          :file-list="studentFileList"
          :limit="1"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传jpg/png文件</div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchUploadVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitBatchUpload">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 发布作业对话框 -->
    <el-dialog
      title="发布作业"
      :visible.sync="publishDialogVisible"
      width="40%"
    >
      <el-form :model="publishForm" label-width="100px">
        <el-form-item label="作业名称">
          <el-input v-model="publishForm.name" disabled />
        </el-form-item>
        <el-form-item label="选择班级" required>
          <el-select
            v-model="publishForm.selectedClassIds"
            multiple
            filterable
            placeholder="请选择要发布的班级"
            style="width: 100%"
          >
            <el-option
              v-for="item in classList"
              :key="item.id"
              :label="item.gradeName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="publishDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handlePublishHomework">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Loading } from 'element-ui'
import ImageHomeworkCreator from './ImageHomeworkCreator.vue'
import {
  getHomeworkList,
  createHomework,
  deleteHomework,
  getKnowledgeContent,
  getQuestionsByKnowledge,
  getTop50Questions,
  getSpecificHomeworkQuestions,
  saveSpecificHomework,
  getStudentSubmissions,
  getStudentUsername,
  getCorrectionResult,
  saveCorrectionResults,
  getQuestionDetail,
  getHomeworkStats,
  updateCorrectionStatus,
  getImageHomeworkList,
  deleteImageHomework,
  publishImageHomework,
  publishHomeworkSingle,
  publishHomeworkMultiple
} from '@/api/homework';
import { classPaging } from '@/api/class';
import { processOcrImage } from '@/api/ai';
import { getQuestionsByRepoId, saveOcrQuestions } from '@/api/amcquestion';
import { addWrongQuestion } from '@/api/userbook';
import { fetchPaging } from '@/api/repo';
import { getUsersByGradeId } from '@/api/user';

export default {
  name: 'homework-correct',
  components: {
    ImageHomeworkCreator
  },
  data() {
    return {
      testdata: [
        {
          'suboptions': '数学',
          'textbookOptions': '人教版',
          'gradeoptions': 3
        }
      ],
      homeworkList: [], // 初始化空数组
      loading: false, // 加载状态
      editDialogVisible: false, // 编辑对话框显示状态
      createDialogVisible: false, // 新建作业对话框显示状态
      batchUploadVisible: false, // 批量上传对话框显示状态
      currentBatchHomework: {}, // 当前批量上传的作业
      studentFileList: [], // 学生批量上传文件列表
      studentSelectList: [], // 学生选择列表

      newHomeworkForm: {
        name: ''
      },
      publishDialogVisible: false, // 发布作业对话框显示状态
      publishForm: {
        name: '',
        selectedClassIds: []
      },
      currentHomework: {}, // 当前编辑的作业
      selectedKnowledgePoint: '', // 选中的知识点
      selectedKnowledgePath: [], // 选中的知识点路径
      knowledgePoints: [], // 知识点列表
      knowledgeIdNameMap: {}, // 知识点ID到名称映射
      knowledgeCascaderProps: {
        value: 'id',
        label: 'content',
        children: 'children',
        emitPath: true,
        checkStrictly: false
      },
      selectedRepoId: '', // 选中的题库ID
      repoList: [], // 题库列表
      questionList: [], // 题目列表
      selectedQuestions: [], // 选中的题目
      questionsLoading: false, // 题目加载状态
      isPublished: false, // 作业发布状态
      classList: [], // 班级列表
      tempHomeworkId: null, // 临时存储要发布的作业ID
      submissions: [], // 存储所有提交记录
      classStats: {}, // 存储班级统计信息
      homeworkStats: {}, // 存储作业统计信息
      correctionResultVisible: false, // 控制批改结果弹窗显示
      correctionResults: [], // 存储批改结果
      studentListVisible: false, // 控制学生列表弹窗显示
      submittedStudents: [], // 存储已提交的学生列表
      currentStudent: null, // 存储当前查看的学生信息
      studentImageDialogVisible: false,
      studentImageUrl: '',
      imageScale: 1,
      imageOffset: { x: 0, y: 0 },
      dragging: false,
      dragStart: { x: 0, y: 0 },
      lastOffset: { x: 0, y: 0 },
      studentList: [],
      currentPage: 1,
      totalPages: 1,
      currentStudentScore: null, // Add new data property for student score
      ocrDialogVisible: false,
      fileList: [],
      answersFileList: [],
      selectedQuType: '',
      quTypeOptions: [
        { value: 1, label: '选择题', type: 'select' },
        { value: 2, label: '填空题', type: 'fill' },
        { value: 3, label: '判断题', type: 'judge' },
        { value: 4, label: '简答题', type: 'application' }
      ],
      studentSubmissions: [], // 存储当前学生的所有提交记录
      currentImageIndex: 0, // 当前查看的图片索引
      inputDialogVisible: false,
      inputQuestionForm: {
        quType: '',
        content: '',
        answer: '',
        knowledge: '',
        analysis: '',
        evaluate: '',
        options: '',
        difficulty: 0.5,
        level: 2
      },
      imageHomeworkCreatorVisible: false,
      autoAddToWrongBook: true, // 默认自动添加错题到错题本
      selectedClassId: null, // 当前选中的班级ID
      classSubmissionData: {} // 存储每个班级的提交数据
    };
  },
  computed: {
    ...mapGetters([
      'name'
    ]),
    totalHomeworks() {
      return this.homeworkList.length
    },
    // 按题目前缀序号排序（如："12."、"12)"、"12、"），无序号则保持相对顺序
    sortedQuestionList() {
      if (!Array.isArray(this.questionList)) return [];
      const withIndex = this.questionList.map((q, idx) => ({ q, idx }));
      const extractNum = (text) => {
        if (!text || typeof text !== 'string') return null;
        // 去掉HTML标签后再匹配序号
        const plain = text.replace(/<[^>]*>/g, '');
        const m = plain.match(/^\s*(\d{1,4})[./)\uff0c\u3001\s]/); // 支持 1. / 1) / 1、/1，
        return m ? parseInt(m[1], 10) : null;
      };
      return withIndex
        .map(({ q, idx }) => ({
          q,
          idx,
          n: extractNum(q.content || q.stem || '')
        }))
        .sort((a, b) => {
          const an = a.n;
          const bn = b.n;
          if (an != null && bn != null) return an - bn;
          if (an != null) return -1; // 有序号的排前面
          if (bn != null) return 1;
          return a.idx - b.idx; // 都无序号按原始顺序
        })
        .map(x => x.q);
    },
    showEmptyState() {
      return !this.questionsLoading && (!this.questionList || this.questionList.length === 0)
    },
    questionTypeCount() {
      const count = {};
      if (!this.currentHomework.questions) return count;
      this.currentHomework.questions.forEach(q => {
        const type = q.quType;
        count[type] = (count[type] || 0) + 1;
      });
      return count;
    },
    totalPoints() {
      if (!this.currentHomework.questions) return 0;
      return this.currentHomework.questions.reduce((sum, q) => {
        // 支持point或score字段
        const p = Number(q.point || q.score) || 0;
        return sum + p;
      }, 0);
    },
    errorQuestionCount() {
      if (!this.correctionResults || !Array.isArray(this.correctionResults)) return 0;
      return this.correctionResults.filter(result => result.judge === 'error').length;
    },
    filteredStudents() {
      // 如果没有选中班级，显示所有学生
      if (!this.selectedClassId) {
        return this.submittedStudents;
      }

      // 根据选中的班级过滤学生
      return this.submittedStudents.filter(student => {
        return this.classSubmissionData[this.selectedClassId]?.includes(student.studentId);
      });
    }
  },
  created() {
    this.checkPermissionAndLoadData()
    // this.getClassListAndHomework();
    classPaging().then(res => {
      console.log('初始函数中的班级列表：', res)
      this.studentList = res.data.records
    })
  },
  watch: {
    // 监听批改结果变化，实时更新错误题目数量
    correctionResults: {
      handler(newVal) {
        if (newVal && Array.isArray(newVal)) {
          console.log('批改结果更新，错误题目数量:', this.errorQuestionCount);
        }
      },
      deep: true
    }
  },
  methods: {
    // 获取作业发布的班级信息
    getPublishedClasses(homework) {
      // 检查是否已发布
      if (!homework.published || !homework.gradeIds || homework.gradeIds.length === 0) {
        return '未发布'
      }

      // 如果有多个班级ID，显示所有班级名称
      if (homework.gradeIds && homework.gradeIds.length > 0) {
        const classNames = homework.gradeIds.map(classId => {
          const classInfo = this.classList.find(c => c.id === classId)
          return classInfo ? (classInfo.gradeName || classInfo.name || `班级${classId}`) : `班级${classId}`
        })
        return classNames.join(', ')
      }

      // 兼容旧数据格式
      if (homework.gradeId || homework.grade_id) {
        const classId = homework.gradeId || homework.grade_id
        const classInfo = this.classList.find(c => c.id === classId)
        return classInfo ? (classInfo.gradeName || classInfo.name || `班级${classId}`) : `班级${classId}`
      }

      return '未发布'
    },

    // 权限检查及数据加载
    async checkPermissionAndLoadData() {
      const roles = localStorage.getItem('roles')
      console.log('Current roles from localStorage:', roles)
      if (roles !== 'teacher') {
        this.$message.error('您没有权限访问此页面')
        return this.$router.push('/404')
      }
      await this.fetchHomeworkList()
    },

    // 获取作业列表
    async fetchHomeworkList() {
      console.log('Fetching homework list')
      this.loading = true
      try {
        // 获取普通作业列表
        const res = await getHomeworkList()
        console.log('Homework list response:', res)
        let homeworkList = []

        if (res && res.data) {
          homeworkList = res.data.map(homework => {
            // 确保gradeId存在
            const gradeId = homework.gradeId || homework.grade_id
            console.log('Processing homework:', homework, 'gradeId:', gradeId)
            return {
              ...homework,
              gradeId: gradeId,
              isImageType: false // 标记为非图片作业
            }
          })
          console.log('Processed homework list:', homeworkList)
        }

        // 获取图片作业列表
        const imageRes = await getImageHomeworkList()
        console.log('Image homework list response:', imageRes)

        if (imageRes && imageRes.data) {
          const imageHomeworkList = imageRes.data.map(homework => ({
            ...homework,
            isImageType: true // 标记为图片作业
          }))

          // 合并两种作业列表
          this.homeworkList = [...homeworkList, ...imageHomeworkList]
        } else {
          this.homeworkList = homeworkList
        }

        // 按当前登录用户ID筛选（与后端返回的 createPerson 对比）
        try {
          const userInfoStr = window.localStorage.getItem('userInfo') || '{}'
          const parsed = JSON.parse(userInfoStr)
          const myId = parsed && parsed.id != null ? String(parsed.id) : ''
          if (myId) {
            this.homeworkList = this.homeworkList.filter(hw => String(hw.createPerson) === myId)
          }
        } catch (e) {
          // 若解析失败则不做筛选
        }

        // 由于后端已经返回了发布状态信息，不需要再调用fetchSubmissionStats
        // await this.fetchSubmissionStats()
      } catch (error) {
        console.error('获取作业列表失败', error)
        this.$message.error('获取作业列表失败，请重试')
      } finally {
        this.loading = false
      }
    },

    // 测试按钮（示例）
    // test() {
    //   console.log('Test button clicked');
    //   axios.get('http://localhost:8080/api/homework/list')
    //     .then(res => {
    //       console.log('Test request response:', res);
    //       this.$message.success('测试请求成功');
    //     })
    //     .catch(err => {
    //       console.error('Test request error:', err);
    //       this.$message.error('测试请求失败');
    //     });
    // },

    // 创建作业对话框
    showCreateDialog() {
      this.createDialogVisible = true
    },

    // 处理新建作业
    async handleCreateHomework() {
      if (!this.newHomeworkForm.name.trim()) {
        this.$message.warning('作业名称不能为空')
        return
      }

      try {
        const loadingInstance = this.$loading({
          lock: true,
          text: '正在创建作业...',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // 创建作业，不指定班级
        const homeworkData = {
          name: this.newHomeworkForm.name,
          creator: this.$store.state.user.name || 'testaccount'
        }
        console.log('Creating homework with data:', homeworkData)
        const response = await createHomework(homeworkData)
        console.log('Create homework response:', response)

        loadingInstance.close()

        // 检查后端返回的code字段
        if (response.code === 1) {
          this.$message.success('作业创建成功')
          this.createDialogVisible = false
          // 重置表单
          this.newHomeworkForm = {
            name: ''
          }
          await this.fetchHomeworkList()
        } else {
          // code不为1表示失败
          this.$message.error(response.msg || '作业创建失败')
        }
      } catch (error) {
        console.error('创建作业失败', error)
        this.$message.error('创建作业失败，请重试')
      }
    },

    // 编辑作业
    async editHomework(homework) {
      this.currentHomework = JSON.parse(JSON.stringify(homework))

      // 判断是否是图片作业
      if (homework.isImageType) {
        // 对于图片作业，打开图片作业编辑器
        console.log('正在编辑图片作业:', homework)

        if (homework.imageUrl) {
          // 使用自建图片作业组件进行编辑
          this.imageHomeworkCreatorVisible = true

          // 下一帧等待组件加载完成
          this.$nextTick(() => {
            // 通过引用获取ImageHomeworkCreator组件实例
            const imageHomeworkCreator = this.$refs.imageHomeworkCreator
            if (imageHomeworkCreator) {
              // 调用组件的编辑方法
              imageHomeworkCreator.editHomework(homework)
            } else {
              this.$message.error('无法获取图片作业编辑器组件')
            }
          })
        } else {
          this.$message.warning('该图片作业没有关联的图片，无法编辑')
        }
        return
      }

      // 普通作业编辑逻辑
      this.editDialogVisible = true

      try {
        // 1. 获取知识点内容
        const params = {
          suboptions: this.testdata[0].suboptions,
          textbookOptions: this.testdata[0].textbookOptions,
          gradeoptions: this.testdata[0].gradeoptions
        }

        console.log('Fetching knowledge content with params:', params)
        const res = await getKnowledgeContent(params)

        console.log('Knowledge content response:', res)
        if (res && res.data) {
          this.knowledgePoints = res.data
        } else {
          console.warn('No knowledge points data received')
        }

        // 2. 获取题库列表
        const repoRes = await fetchPaging()
        console.log('Repo list response:', repoRes)
        if (repoRes && repoRes.data) {
          this.repoList = repoRes.data
          console.log('Loaded repo list:', this.repoList)
        }

        // 3. 初始化题目列表为空（用户可以通过OCR或手动输入添加题目）
        this.questionList = []
        console.log('Initialized question list as empty')

        // 4. 获取当前作业的题目列表
        console.log('Fetching questions for homework:', homework.id)
        const specificQuestionsRes = await getSpecificHomeworkQuestions(homework.id)
        console.log('Specific homework questions response:', specificQuestionsRes)

        if (specificQuestionsRes && specificQuestionsRes.data) {
          const questionsWithoutClassID = specificQuestionsRes.data.map(question => {
            const { classID, ...rest } = question
            return rest
          })
          this.$set(this.currentHomework, 'questions', questionsWithoutClassID)
          console.log('Current homework questions updated:', this.currentHomework.questions)
        } else {
          console.warn('No specific homework questions received')
          this.$set(this.currentHomework, 'questions', [])
        }
      } catch (error) {
        console.error('Error details:', {
          message: error.message,
          response: error.response,
          config: error.config
        })
        this.$message.error('获取数据失败: ' + (error.response?.data?.message || error.message))
      }
    },

    // 处理对话框关闭
    handleClose(done) {
      this.$confirm('确认关闭？未保存的内容将会丢失')
        .then(_ => {
          this.currentHomework = {}
          done()
        })
        .catch(_ => { })
    },

    // 保存作业
    async saveHomework() {
      if (!this.currentHomework.questions || this.currentHomework.questions.length === 0) {
        this.$message.warning('请先添加题目')
        return
      }

      try {
        const loadingInstance = this.$loading({
          lock: true,
          text: '正在保存作业...',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // 构建符合后端API要求的数据格式
        const questionsData = this.currentHomework.questions.map(question => ({
          content: question.content || question.stem || '',
          quType: question.quType || 1,
          gradeId: question.gradeId || 1, // 默认班级ID，实际应该从作业或用户信息获取
          point: question.point || question.score || 10, // 默认分数
          answer: question.answer || '' // 确保包含答案字段
        }))

        console.log('Sending questions data:', questionsData)

        // 调用后端API保存作业题目
        const response = await saveSpecificHomework(this.currentHomework.id, questionsData)
        console.log('Save homework response:', response)

        loadingInstance.close()

        // 检查后端返回的code字段
        if (response.code === 1) {
          this.$message.success('保存成功')
          this.editDialogVisible = false

          // 更新作业列表中的题目数据
          const homeworkIndex = this.homeworkList.findIndex(h => h.id === this.currentHomework.id)
          if (homeworkIndex !== -1) {
            this.homeworkList[homeworkIndex].questions = this.currentHomework.questions
          }
        } else {
          // code不为1表示失败
          this.$message.error(response.msg || '保存失败')
        }
      } catch (error) {
        console.error('保存作业失败', error)
        this.$message.error('保存失败，请重试')
      }
    },

    // 获取班级列表
    async fetchClassList() {
      try {
        // const res = await axios.get('http://localhost:8080/api/knowledge-points');
        const res = await classPaging()
        if (res && res.data) {
          this.classList = res.data.records
        }
      } catch (error) {
        console.error('获取班级列表失败', error)
        this.$message.error('获取班级列表失败')
      }
    },

    // 发布作业
    async publishHomework(homeworkId) {
      // 获取当前作业项
      const homework = this.homeworkList.find(h => h.id === homeworkId)
      console.log('Found homework:', homework)

      if (!homework) {
        this.$message.error('未找到要发布的作业')
        return
      }

      // 检查是否是图片作业
      if (!homework.isImageType) {
        // 普通作业需要检查题目 - 从数据库重新获取最新数据
        try {
          console.log('Fetching latest questions for homework:', homeworkId)
          const questionsRes = await getSpecificHomeworkQuestions(homeworkId)
          console.log('Latest questions response:', questionsRes)

          if (!questionsRes || !questionsRes.data || questionsRes.data.length === 0) {
            this.$message.warning('该作业没有题目，请先添加题目')
            return
          }

          // 更新本地作业数据中的题目信息
          homework.questions = questionsRes.data
          console.log('Updated homework questions:', homework.questions)
        } catch (error) {
          console.error('获取作业题目失败:', error)
          this.$message.error('获取作业题目失败，请重试')
          return
        }
      }

      // 设置发布表单数据
      this.publishForm = {
        name: homework.name,
        selectedClassIds: []
      }
      this.tempHomeworkId = homeworkId

      // 获取班级列表并显示发布对话框
      await this.fetchClassList()
      this.publishDialogVisible = true
    },

    // 处理发布作业
    async handlePublishHomework() {
      if (this.publishForm.selectedClassIds.length === 0) {
        this.$message.warning('请至少选择一个班级')
        return
      }

      try {
        const confirm = await this.$confirm('确定要发布该作业吗？发布后学生将可以看到作业内容。', '发布确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).catch(() => false)

        if (!confirm) return

        const loadingInstance = this.$loading({
          lock: true,
          text: '正在发布作业...',
          background: 'rgba(0, 0, 0, 0.7)'
        })

                try {
          // 获取当前作业项
          const homework = this.homeworkList.find(h => h.id === this.tempHomeworkId)

          if (homework.isImageType) {
            // 图片作业发布逻辑
            await publishImageHomework(this.tempHomeworkId)
          } else {
            // 普通作业发布逻辑
            if (this.publishForm.selectedClassIds.length === 1) {
              // 单班级发布：使用单班级发布接口
              const classId = this.publishForm.selectedClassIds[0]
              const publishData = {
                name: homework.name,
                subject: homework.subject || '数学'
              }

              if (homework.questions && homework.questions.length > 0) {
                publishData.count = homework.questions.length
              }

              console.log('Publishing homework to single class:', classId, publishData)
              const response = await publishHomeworkSingle(this.tempHomeworkId, classId, publishData)

              if (response.code !== 1) {
                throw new Error(response.msg || `发布到班级${classId}失败`)
              }
            } else {
              // 多班级发布：使用批量发布接口
              const publishData = {
                name: homework.name,
                gradeIds: this.publishForm.selectedClassIds,
                subject: homework.subject || '数学'
              }

              if (homework.questions && homework.questions.length > 0) {
                publishData.count = homework.questions.length
              }

              console.log('Publishing homework to multiple classes:', this.publishForm.selectedClassIds, publishData)
              const response = await publishHomeworkMultiple(this.tempHomeworkId, publishData)

              if (response.code !== 1) {
                throw new Error(response.msg || '批量发布失败')
              }
            }
          }

          loadingInstance.close()
          this.$message.success('发布成功')
          this.publishDialogVisible = false
          await this.fetchHomeworkList()
        } catch (error) {
          loadingInstance.close()
          throw error
        }
      } catch (error) {
        console.error('发布作业失败', error)
        this.$message.error('发布失败，请重试')
      }
    },

    // 删除作业
    async deleteHomework(homeworkId) {
      const confirm = await this.$confirm('确定要删除该作业吗？', '删除确认', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(() => false)

      if (confirm) {
        try {
          // 获取要删除的作业项
          const homework = this.homeworkList.find(h => h.id === homeworkId)

          if (!homework) {
            this.$message.error('未找到要删除的作业')
            return
          }

          if (homework.isImageType) {
            // 使用图片作业删除API
            await deleteImageHomework(homeworkId)
          } else {
            // 使用普通作业删除API
          await deleteHomework(homeworkId)
          }

          await this.fetchHomeworkList()
          this.$message.success('作业删除成功')
        } catch (error) {
          this.$message.error('作业删除失败，请重试')
        }
      }
    },

    // 获取知识点列表
    async fetchKnowledgePoints() {
      try {
        // const res = await axios.get('http://localhost:8080/api/knowledge-points');
        const res = await getKnowledge()
        this.knowledgePoints = res.data || []
        this.knowledgeIdNameMap = {}
        const fillMap = (nodes) => {
          if (!Array.isArray(nodes)) return
          nodes.forEach(node => {
            if (node && node.id != null && node.content != null) {
              this.$set(this.knowledgeIdNameMap, String(node.id), String(node.content))
            }
            if (node && node.children && node.children.length) {
              fillMap(node.children)
            }
          })
        }
        fillMap(this.knowledgePoints)
      } catch (error) {
        console.error('获取知识点列表失败', error)
        this.$message.error('获取知识点列表失败')
      }
    },

    handleKnowledgeChange(pathIds) {
      if (!pathIds || !pathIds.length) {
        this.selectedKnowledgePoint = ''
        return
      }
      const lastId = pathIds[pathIds.length - 1]
      this.selectedKnowledgePoint = this.knowledgeIdNameMap[String(lastId)] || ''
    },

    // 搜索题目
    async searchQuestions() {
      if (!this.selectedKnowledgePoint && !this.selectedRepoId) {
        this.$message.warning('请先选择知识点或题库')
        return
      }

      this.questionsLoading = true
      try {
        let res
        if (this.selectedRepoId) {
          // 按题库筛选
          console.log('Searching questions by repo ID:', this.selectedRepoId)
          res = await getQuestionsByRepoId(this.selectedRepoId)
        } else if (this.selectedKnowledgePoint) {
          // 按知识点筛选
          console.log('Searching questions by knowledge:', this.selectedKnowledgePoint)
          res = await getQuestionsByKnowledge({
            knowledge: this.selectedKnowledgePoint
          })
        }

        console.log('Questions response:', res)
        if (res && res.data) {
          // 将搜索到的题目添加到左侧题目列表中（而不是替换）
          const newQuestions = res.data.map(q => ({
            ...q,
            point: q.point || 10 // 确保有分数字段
          }))
          this.questionList = [...this.questionList, ...newQuestions]
          console.log('Added questions to list:', this.questionList)
          this.$message.success(`已添加 ${newQuestions.length} 道题目到题目列表`)
        }
      } catch (error) {
        console.error('获取题目列表失败', error)
        this.$message.error('获取题目列表失败，请重试')
      } finally {
        this.questionsLoading = false
      }
    },

    // 重置题目
    async resetQuestions() {
      this.questionsLoading = true
      try {
        // 清空题目列表
        this.questionList = []
        this.selectedKnowledgePoint = ''
        this.selectedKnowledgePath = []
        this.selectedRepoId = ''
        this.selectedQuestions = []
        this.$message.success('题目列表已清空')
      } catch (error) {
        this.$message.error('重置题目列表失败')
      } finally {
        this.questionsLoading = false
      }
    },

    // 添加选中的题目
    async addSelectedQuestions() {
      const selectedQuestionDetails = this.questionList.filter(q =>
        this.selectedQuestions.includes(q.id)
      )

      // 如果currentHomework.questions不存在，初始化为空数组
      if (!this.currentHomework.questions) {
        this.$set(this.currentHomework, 'questions', [])
      }

      // 为每个选中的题目获取详细信息（包括答案）
      const questionsWithDetails = []
      for (const question of selectedQuestionDetails) {
        try {
          // 如果题目已经有答案字段，直接使用
          if (question.answer) {
            questionsWithDetails.push(question)
          } else {
            // 否则尝试获取题目详情
            const detailResponse = await getQuestionDetail(question.id)
            if (detailResponse && detailResponse.data) {
              questionsWithDetails.push({
                ...question,
                answer: detailResponse.data.answer || ''
              })
            } else {
              // 如果获取详情失败，使用原题目数据
              questionsWithDetails.push({
                ...question,
                answer: ''
              })
            }
          }
        } catch (error) {
          console.warn(`获取题目 ${question.id} 详情失败:`, error)
          // 如果获取详情失败，使用原题目数据
          questionsWithDetails.push({
            ...question,
            answer: ''
          })
        }
      }

      // 添加选中的题目到作业中
      this.currentHomework.questions.push(...questionsWithDetails)

      // 清空选中状态
      this.selectedQuestions = []

      this.$message.success(`已添加 ${questionsWithDetails.length} 道题目`)
    },

    // 移除题目
    removeQuestion(index) {
      this.$confirm('确定要移除这道题目吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.currentHomework.questions.splice(index, 1)
        this.$message.success('题目已移除')
      }).catch(() => { })
    },

    // 获取题目类型描述
    getQuestionType(type) {
      const typeMap = {
        1: '选择题',
        2: '判断题',
        3: '填空题',
        4: '计算题',
        5: '解答题'
      }
      return typeMap[Number(type)] || '未知类型'
    },

    // 获取提交统计信息
    async fetchSubmissionStats() {
      try {
        const submissionsRes = await getStudentSubmissions()
        if (!submissionsRes) {
          throw new Error('获取提交记录失败：服务器返回数据为空')
        }
        this.submissions = submissionsRes

        const gradesRes = await classPaging()
        if (!gradesRes) {
          throw new Error('获取班级信息失败：服务器返回数据为空')
        }

        console.log('班级数据原始格式:', gradesRes)

        if (gradesRes.data && gradesRes.data.records && Array.isArray(gradesRes.data.records)) {
          this.classStats = gradesRes.data.records.reduce((acc, grade) => {
            if (grade && grade.id && grade.gradeCount) {
              acc[grade.id] = grade.gradeCount
            }
            return acc
          }, {})
        } else {
          console.warn('班级数据格式不正确，无法解析:', gradesRes)
          this.classStats = {}
        }

        console.log('处理后的班级统计信息:', this.classStats)

        this.homeworkList = this.homeworkList.map(homework => {
          // 获取该作业的所有提交记录
          const homeworkSubmissions = this.submissions.filter(
            sub => sub.homeworkId === homework.id && sub.submitted
          )

          // 使用Set去重，只统计不同的学生ID
          const uniqueStudentIds = new Set(
            homeworkSubmissions.map(sub => sub.studentId)
          )

          const totalStudents = this.classStats[homework.gradeId] || 0
          const submissionCount = uniqueStudentIds.size // 使用去重后的学生数量

          return {
            ...homework,
            submissionCount,
            totalStudents
          }
        })
      } catch (error) {
        console.error('获取提交统计信息失败:', error)
        if (error.response) {
          this.$message.error(`获取提交统计信息失败：${error.response.data.message || '服务器错误'}`)
        } else if (error.request) {
          this.$message.error('获取提交统计信息失败：无法连接到服务器，请检查网络连接')
        } else {
          this.$message.error(`获取提交统计信息失败：${error.message}`)
        }
      }
    },

    async handleHomeworkNameClick(homework) {
      try {
        // 显示加载状态
        const loadingInstance = this.$loading({
          lock: true,
          text: '正在加载学生信息...',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        // 获取统计信息
        await this.fetchHomeworkStats(homework.id)

        const submissionsRes = await getStudentSubmissions()
        const submissions = submissionsRes || []

        console.log('所有提交记录:', submissions);
        console.log('当前作业ID:', homework.id);
        console.log('当前作业ID类型:', typeof homework.id);

        // 检查提交记录的数据结构
        if (submissions.length > 0) {
          console.log('第一条提交记录的结构:', submissions[0]);
          console.log('第一条提交记录的字段:', Object.keys(submissions[0]));
        }

        // 获取所有提交的学生ID，并去重
        const studentIds = [...new Set(
          submissions
            .filter(sub => {
              // 尝试多种可能的字段名和类型匹配
              const homeworkIdMatch = sub.homeworkId === homework.id ||
                                    sub.homeworkId === String(homework.id) ||
                                    sub.homework_id === homework.id ||
                                    sub.homework_id === String(homework.id) ||
                                    String(sub.homeworkId) === String(homework.id);
              return homeworkIdMatch;
            })
            .map(sub => sub.studentId || sub.student_id)
        )];

        console.log('过滤后的提交记录:', submissions.filter(sub => {
          const homeworkIdMatch = sub.homeworkId === homework.id ||
                                sub.homeworkId === String(homework.id) ||
                                sub.homework_id === homework.id ||
                                sub.homework_id === String(homework.id) ||
                                String(sub.homeworkId) === String(homework.id);
          return homeworkIdMatch;
        }));
        console.log('提取的学生ID:', studentIds);

        const userPromises = studentIds.map(id =>
          getStudentUsername(id).then(res => ({
            studentId: id,
            username: res.msg
          }))
        );
        const userList = await Promise.all(userPromises);

        // 计算总学生数（基于发布的班级）
        let totalStudents = 0;
        if (homework.gradeIds && homework.gradeIds.length > 0) {
          // 根据发布的班级计算总学生数
          for (const classId of homework.gradeIds) {
            const classInfo = this.classList.find(c => c.id === classId);
            if (classInfo && classInfo.gradeCount) {
              totalStudents += classInfo.gradeCount;
            }
          }
        }

        // 按班级分组提交数据
        this.classSubmissionData = {};
        if (homework.gradeIds && homework.gradeIds.length > 0) {
          // 为每个班级获取学生信息
          for (const classId of homework.gradeIds) {
            try {
              // 获取该班级的所有学生
              const classUsersRes = await getUsersByGradeId(classId);
              const classUsers = classUsersRes.data || [];

              console.log(`班级${classId}的学生数据:`, classUsers);

              // 获取该班级学生的ID列表（确保类型一致）
              const classStudentIds = classUsers.map(user => String(user.id));
              console.log(`班级${classId}的学生ID列表:`, classStudentIds);
              console.log(`所有提交作业的学生ID:`, studentIds);

              // 找出该班级中提交了作业的学生（确保类型一致）
              const submittedStudentIds = studentIds.filter(studentId =>
                classStudentIds.includes(String(studentId))
              );

              console.log(`班级${classId}提交作业的学生ID:`, submittedStudentIds);

              this.classSubmissionData[classId] = submittedStudentIds;
            } catch (error) {
              console.error(`获取班级${classId}学生信息失败:`, error);
              this.classSubmissionData[classId] = [];
            }
          }
        }

        console.log('最终的班级提交数据:', this.classSubmissionData);

        this.currentHomework = {
          ...homework,
          submissionCount: userList.length,
          totalStudents: totalStudents
        };
        this.submittedStudents = userList;
        this.selectedClassId = null; // 重置选中状态

        loadingInstance.close();
        this.studentListVisible = true;
      } catch (error) {
        this.$message.error('获取学生列表失败');
        console.error(error);
      }
    },

    // 选择班级
    selectClass(classId) {
      this.selectedClassId = this.selectedClassId === classId ? null : classId;
    },

    // 获取班级名称
    getClassName(classId) {
      const classInfo = this.classList.find(c => c.id === classId);
      return classInfo ? (classInfo.gradeName || classInfo.name || `班级${classId}`) : `班级${classId}`;
    },

    // 获取班级提交人数
    getClassSubmissionCount(classId) {
      const submittedStudentIds = this.classSubmissionData[classId] || [];
      return submittedStudentIds.length;
    },

    // 获取学生所属班级（这个方法需要根据实际的学生班级关系API来实现）
    async getStudentClass(studentId) {
      // 这里需要调用API获取学生所属的班级
      // 例如：GET /api/student/{studentId}/class
      // 暂时返回null，你可以根据实际API来实现
      return null;
    },

            // 数学公式渲染方法
    renderMathFormula(content) {
      if (!content) return '';

      try {
        if (window.katex) {
          let processedContent = content;

          // 先处理转义的内联数学公式 \\(...\\) - 这是后端数据的主要格式
          processedContent = processedContent.replace(/\\\\([^)]+)\\\\/g, (match, formula) => {
            try {
              return window.katex.renderToString(formula, {
                throwOnError: false,
                displayMode: false
              });
            } catch (e) {
              console.warn('转义内联公式渲染失败:', formula, e);
              return match;
            }
          });

          // 处理内联数学公式 \(...\)
          processedContent = processedContent.replace(/\\\(([^)]+)\\\)/g, (match, formula) => {
            try {
              return window.katex.renderToString(formula, {
                throwOnError: false,
                displayMode: false
              });
            } catch (e) {
              console.warn('内联公式渲染失败:', formula, e);
              return match;
            }
          });

          // 处理转义的块级数学公式 \\[...\\]
          processedContent = processedContent.replace(/\\\\\[([^\]]+)\\\]/g, (match, formula) => {
            try {
              return window.katex.renderToString(formula, {
                throwOnError: false,
                displayMode: true
              });
            } catch (e) {
              console.warn('转义块级公式渲染失败:', formula, e);
              return match;
            }
          });

          // 处理块级数学公式 \[...\]
          processedContent = processedContent.replace(/\\\[([^\]]+)\\\]/g, (match, formula) => {
            try {
              return window.katex.renderToString(formula, {
                throwOnError: false,
                displayMode: true
              });
            } catch (e) {
              console.warn('块级公式渲染失败:', formula, e);
              return match;
            }
          });

          // 处理美元符号包围的公式 $...$
          processedContent = processedContent.replace(/\$([^$]+)\$/g, (match, formula) => {
            try {
              return window.katex.renderToString(formula, {
                throwOnError: false,
                displayMode: false
              });
            } catch (e) {
              console.warn('美元符号公式渲染失败:', formula, e);
              return match;
            }
          });

          return processedContent;
        } else {
          // 如果没有KaTeX，使用简单的HTML替换
          let result = content;
          result = result.replace(/\\frac\{([^}]+)\}\{([^}]+)\}/g, '<sup>$1</sup>/<sub>$2</sub>');
          result = result.replace(/\\sqrt\{([^}]+)\}/g, '√$1');
          result = result.replace(/\^(\d+)/g, '<sup>$1</sup>');
          result = result.replace(/_(\d+)/g, '<sub>$1</sub>');
          result = result.replace(/\\\\([^)]+)\\\\/g, '');
          result = result.replace(/\\\(([^)]+)\\\)/g, '');
          result = result.replace(/\\\\\[([^\]]+)\\\]/g, '');
          result = result.replace(/\\\[([^\]]+)\\\]/g, '');
          return result;
        }
      } catch (error) {
        console.warn('数学公式渲染失败:', error);
        return content;
      }
    },

    async showCorrectionResult(student) {
      try {
        const result = await getCorrectionResult(this.currentHomework.id, student.studentId);
        const submissionsRes = await getStudentSubmissions();
        console.log('submissionsRes:', submissionsRes);
        // 获取该学生的所有提交记录
        this.studentSubmissions = submissionsRes.filter(
          s => s.homeworkId === this.currentHomework.id && s.studentId === student.studentId
        ).sort((a, b) => new Date(b.submitTime) - new Date(a.submitTime)); // 按提交时间倒序排序

        if (this.studentSubmissions.length > 0) {
          this.currentImageIndex = 0;
          this.studentImageUrl = this.studentSubmissions[0].imageUrl;
        } else {
          this.studentImageUrl = '';
        }

        this.currentStudent = student;
        this.currentStudentScore = this.studentSubmissions.length > 0 ? this.studentSubmissions[0].point : null;

        // 处理不同类型作业的批改结果
        if (this.currentHomework.isImageType) {
          // 图片作业只显示图片，无需加载题目
          this.correctionResults = [];
          // 如果有批改结果，则直接使用
          if (result && Array.isArray(result) && result.length > 0) {
            this.correctionResults = result;
          }
        } else {
          // 普通作业处理逻辑
          // 如果批改结果为空，则用作业题目详情填充
        if (!result || (Array.isArray(result) && result.length === 0)) {
          const questionsRes = await getSpecificHomeworkQuestions(this.currentHomework.id);
          if (questionsRes && questionsRes.data) {
            this.correctionResults = questionsRes.data.map(q => ({
              stem: q.content || q.stem || '',
              judge: '', // 未批改
              comment: '',
              point: 0, // 新增分数字段
              ...q
            }));
          } else {
            this.correctionResults = [];
          }
        } else {
          this.correctionResults = result;
        }
        }

        this.studentListVisible = false;
        this.correctionResultVisible = true;
      } catch (error) {
        this.$message.error('获取批改结果失败');
        console.error(error);
      }
    },

    // 切换到上一张图片
    prevImage() {
      if (this.currentImageIndex > 0) {
        this.currentImageIndex--;
        this.studentImageUrl = this.studentSubmissions[this.currentImageIndex].imageUrl;
        this.currentStudentScore = this.studentSubmissions[this.currentImageIndex].point;
      }
    },

    // 切换到下一张图片
    nextImage() {
      if (this.currentImageIndex < this.studentSubmissions.length - 1) {
        this.currentImageIndex++;
        this.studentImageUrl = this.studentSubmissions[this.currentImageIndex].imageUrl;
        this.currentStudentScore = this.studentSubmissions[this.currentImageIndex].point;
      }
    },

    async saveCorrectionResults() {
      try {
        const studentId = this.currentStudent && this.currentStudent.studentId;
        const homeworkId = this.currentHomework && this.currentHomework.id;
        const results = this.correctionResults.map(r => ({
          ...r,
          studentId
        }));
        await saveCorrectionResults(results);
        // 计算总分
        const totalPoint = results.reduce((sum, r) => sum + (Number(r.point) || 0), 0);
        // 更新批改状态
        await updateCorrectionStatus({
          homeworkId,
          studentId,
          status: '已批改',
          point: totalPoint
        });

        // 自动添加错误题目到错题本（如果用户选择了该选项）
        if (this.autoAddToWrongBook) {
          await this.addWrongQuestionsToUserbook(results, studentId);
        }

        this.$message.success('保存成功');
        this.correctionResultVisible = false;
      } catch (error) {
        this.$message.error('保存失败');
        console.error(error);
      }
    },

    handleJudgeChange(index, val) {
      this.correctionResults[index].judge = val
    },

    async showStudentImage() {
      if (!this.currentStudent || !this.currentHomework) {
        this.$message.warning('未获取到学生或作业信息')
        return
      }
      try {
        const res = await axios.get('http://localhost:8080/api/student-submissions')
        if (Array.isArray(res.data)) {
          const submission = res.data.find(
            s => s.homeworkId === this.currentHomework.id && s.studentId === this.currentStudent.studentId
          )
          if (submission && submission.imageUrl) {
            this.studentImageUrl = submission.imageUrl
          } else {
            this.studentImageUrl = ''
            this.$message.info('未找到该学生的作业图片')
          }
        }
        this.studentImageDialogVisible = true
      } catch (e) {
        this.$message.error('获取作业图片失败')
        this.studentImageDialogVisible = true
      }
    },

    handleImageWheel(e) {
      const delta = e.deltaY < 0 ? 0.1 : -0.1
      let newScale = this.imageScale + delta
      newScale = Math.max(0.2, Math.min(newScale, 5))
      this.imageScale = newScale
    },

    startDrag(e) {
      if (e.button !== 0) return // 只响应左键
      this.dragging = true
      this.dragStart = { x: e.clientX, y: e.clientY }
      this.lastOffset = { ...this.imageOffset }
      window.addEventListener('mousemove', this.onDrag)
      window.addEventListener('mouseup', this.stopDrag)
    },
    stopDrag() {
      this.dragging = false
      window.removeEventListener('mousemove', this.onDrag)
      window.removeEventListener('mouseup', this.stopDrag)
    },
    onDrag(e) {
      if (!this.dragging) return
      this.imageOffset = {
        x: this.lastOffset.x + (e.clientX - this.dragStart.x),
        y: this.lastOffset.y + (e.clientY - this.dragStart.y)
      }
    },

    async addWrongQuestion(question) {
      try {
        const userId = localStorage.getItem('userId')
        if (!userId) {
          this.$message.error('用户ID不存在')
          return
        }

        // 获取题目详情
        const detailRes = await getQuestionDetail(question.id)
        if (!detailRes || !detailRes.data) {
          this.$message.error('获取题目详情失败')
          return
        }

        await addWrongQuestion({
          student_id: userId,
          content: question.stem,
          analysis: question.comment || '',
          knowledge: detailRes.data.knowledge || '',
          chapter: '',
          suboptions: '数学',
          answer: detailRes.data.answer || ''
        })

        this.$message.success('添加错题成功')
      } catch (error) {
        console.error('添加错题失败:', error)
        this.$message.error('添加错题失败')
      }
    },

    // 自动添加错误题目到学生的错题本
    async addWrongQuestionsToUserbook(results, studentId) {
      try {
        // 验证参数
        if (!studentId) {
          console.warn('学生ID为空，无法添加错题到错题本');
          return;
        }

        if (!Array.isArray(results) || results.length === 0) {
          console.log('没有批改结果，无法添加错题到错题本');
          return;
        }

        // 筛选出判断为错误的题目
        const wrongQuestions = results.filter(result => result.judge === 'error');

        if (wrongQuestions.length === 0) {
          console.log('没有错误题目需要添加到错题本');
          return;
        }

        console.log(`发现 ${wrongQuestions.length} 道错误题目，正在添加到错题本...`);

        let successCount = 0;
        let failCount = 0;

        // 检查是否是图片作业
        const isImageHomework = this.currentHomework && this.currentHomework.isImageType;

        // 为每个错误题目添加到错题本
        for (const question of wrongQuestions) {
          try {
            // 尝试获取题目详情以获取更完整的信息
            let questionDetail = null;
            if (question.id && !isImageHomework) {
              try {
                const detailRes = await getQuestionDetail(question.id);
                if (detailRes && detailRes.data) {
                  questionDetail = detailRes.data;
                }
              } catch (detailError) {
                console.warn('获取题目详情失败，使用现有数据:', detailError);
              }
            }

            // 构建错题数据
            const wrongQuestionData = {
              studentId: studentId, // 使用学生ID
              content: question.stem || question.content || questionDetail?.content || '', // 题目内容
              analysis: question.comment || questionDetail?.analysis || '', // 教师评语或题目解析
              knowledge: question.knowledge || question.chapter || questionDetail?.knowledge || '', // 知识点
              chapter: question.chapter || questionDetail?.chapter || '', // 章节
              suboptions: '数学', // 默认学科
              answer: question.answer || questionDetail?.answer || '' // 正确答案
            };

            // 对于图片作业，如果没有题目内容，尝试从图片URL生成描述
            if (isImageHomework && !wrongQuestionData.content.trim() && this.studentImageUrl) {
              wrongQuestionData.content = `图片作业题目 (来自作业: ${this.currentHomework.name || '未知作业'})`;
            }

            // 验证必要字段
            if (!wrongQuestionData.content.trim()) {
              console.warn('题目内容为空，跳过添加');
              failCount++;
              continue;
            }

            console.log('添加错题数据:', wrongQuestionData);

            // 调用API添加错题
            await addWrongQuestion(wrongQuestionData);
            successCount++;
          } catch (error) {
            console.error(`添加错题失败 (题目: ${question.stem || question.content}):`, error);
            failCount++;
            // 继续处理其他题目，不中断整个流程
          }
        }

        // 显示结果消息
        if (successCount > 0) {
          let message = `已成功将 ${successCount} 道错误题目添加到学生错题本`;
          if (failCount > 0) {
            message += `，${failCount} 道题目添加失败`;
          }
          this.$message.success(message);
        } else if (failCount > 0) {
          this.$message.warning(`${failCount} 道错误题目添加失败，请检查网络连接或稍后重试`);
        }
      } catch (error) {
        console.error('批量添加错题到错题本失败:', error);
        // 不显示错误消息，避免影响正常的批改保存流程
      }
    },

    async prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
        await this.fetchCorrectionResults()
      }
    },

    async nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
        await this.fetchCorrectionResults()
      }
    },

    async fetchCorrectionResults() {
      try {
        const res = await getCorrectionResult(this.currentHomework.id, this.currentStudent.studentId, this.currentPage)
        if (res && res.data) {
          this.correctionResults = res.data
          this.totalPages = res.totalPages
        }
      } catch (error) {
        console.error('获取批改结果失败', error);
        this.$message.error('获取批改结果失败');
      }
    },

    // 显示OCR对话框
    showOcrDialog() {
      this.ocrDialogVisible = true;
      this.fileList = [];
      this.answersFileList = [];
    },

    // 处理文件变化（支持多选）
    handleFileChange(file, fileList) {
      this.fileList = fileList;
    },
    handleAnswersFileChange(file, fileList) {
      this.answersFileList = fileList;
    },

    // 删除文件
    handleFileRemove(file, fileList) {
      this.fileList = fileList;
    },
    handleAnswersFileRemove(file, fileList) {
      this.answersFileList = fileList;
    },

    // 处理图片上传
    // 将后端返回的题目类型字符串转换为前端使用的数字类型
    convertQuestionType(backendType) {
      const typeMapping = {
        'select': 1,
        'fill': 2,
        'judge': 3,
        'application': 4,
        'short_answer': 4, // 简答题对应application类型
        'multiple_choice': 1, // 选择题
        'true_false': 3, // 判断题
        'fill_blank': 2 // 填空题
      };
      return typeMapping[backendType] || 1; // 默认返回选择题类型
    },

    // 获取题目类型名称
    getQuestionTypeName(quType) {
      const typeMap = {
        1: '选择题',
        2: '填空题',
        3: '判断题',
        4: '计算题',
        5: '解答题'
      };
      return typeMap[quType] || '计算题';
    },

    // 格式化难度显示
    formatDifficulty(value) {
      if (value <= 0.3) return '简单';
      if (value <= 0.6) return '中等';
      if (value <= 0.8) return '较难';
      return '困难';
    },

    // 处理选项格式转换
    formatOptions(options, quType) {
      // 填空题和其他题型：options保持为空字符串
      if (quType !== 1) {
        return '';
      }

      if (!options) {
        return '';
      }

      // 选择题：处理各种可能的选项格式
      if (Array.isArray(options)) {
        // 数组格式：["A. 选项1", "B. 选项2"] -> "A. 选项1;B. 选项2"
        return options.join(';');
      } else if (typeof options === 'string') {
        // 字符串格式：检查是否已经是分号分隔
        if (options.includes(';')) {
          return options; // 已经是分号分隔格式
        } else if (options.includes(',')) {
          // 逗号分隔格式：转换为分号分隔
          return options.replace(/,/g, ';');
        } else {
          // 其他格式：直接返回
          return options;
        }
      }

      return '';
    },

    handleImageUpload() {
      if (!this.fileList || this.fileList.length === 0) {
        this.$message.warning('请选择题目图片后再上传！');
        return;
      }

      const loadingInstance = this.$loading({
        lock: true,
        text: 'OCR识别中，请稍后...（一次性上传多张图片）',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      // 后端要求：
      // - 多张题目图放在参数名 image 中（可多张）
      // - 参考答案图放在参数名 answers 中（1张）
      console.log('=== 文件上传调试信息 ===');
      console.log('题目图片数量:', this.fileList.length);
      this.fileList.forEach((f, index) => {
        console.log(`题目图片${index + 1}:`, {
          name: f.name,
          size: f.size,
          type: f.type,
          lastModified: f.lastModified
        });
      });

      // 推断并规范文件名（保留原扩展名；若无则根据MIME推断）
      const getSafeFileName = (fileLike, index, prefix) => {
        const raw = fileLike && (fileLike.raw instanceof File ? fileLike.raw : fileLike.raw);
        const originalName = (raw && raw.name) || (fileLike && fileLike.name);
        if (originalName && typeof originalName === 'string') return originalName;
        const mime = (raw && raw.type) || '';
        let ext = '';
        if (mime && mime.indexOf('/') > -1) {
          ext = mime.split('/')[1] || '';
        }
        if (!ext) ext = 'jpg';
        return `${prefix}_${index + 1}.${ext}`;
      };

      const formData = new FormData();
      this.fileList.forEach((f, index) => {
        if (!f || !f.raw) {
          console.warn('跳过无效的文件条目（无 raw）:', f);
          return;
        }
        const fileObj = f.raw; // 确保是原始 File 对象
        const fileName = getSafeFileName(f, index, 'image');
        console.log(`添加文件${index + 1}到FormData:`, fileName);
        formData.append('image', fileObj, fileName);
      });

      // 验证FormData中的文件数量
      console.log('FormData验证:');
      const imagesAppended = formData.getAll ? formData.getAll('image') : [];
      if (imagesAppended && imagesAppended.length) {
        imagesAppended.forEach((v, idx) => console.log(`image字段${idx + 1}:`, v && v.name));
        console.log(`FormData中image字段总数: ${imagesAppended.length}`);
      } else {
        // 兼容性：在不支持getAll的环境，退回遍历entries的方式
        let imageCount = 0;
        for (let [key, value] of formData.entries()) {
          if (key === 'image') {
            imageCount++;
            console.log(`image字段${imageCount}:`, value && value.name);
          }
        }
        console.log(`FormData中image字段总数(兼容模式): ${imageCount}`);
      }

      // 参考答案：可选。仅在存在文件时追加，避免发送字符串 'null'
      if (this.answersFileList && this.answersFileList[0] && this.answersFileList[0].raw) {
        const ansFile = this.answersFileList[0].raw; // 确保是原始 File 对象
        const ansName = getSafeFileName(this.answersFileList[0], 0, 'answers');
        formData.append('answers', ansFile, ansName);
        console.log('添加答案图片:', ansName);
      }

      const startTime = Date.now();
      processOcrImage(formData)
        .then(async (response) => {
          const endTime = Date.now();
          const duration = (endTime - startTime) / 1000;
          console.log(`OCR处理耗时: ${duration}秒`);
          console.log('OCR原始返回：', response);
          console.log('返回题目数量:', response.data.count);

          loadingInstance.close();
          const questions = response.data.questions;
          if (!Array.isArray(questions) || questions.length === 0) {
            this.$message.warning('未识别到题目');
            return;
          }

          const questionsToSave = questions.map(question => {
            const quType = this.convertQuestionType(question.question_type);
            return {
              quType: quType,
              content: question.question_content || '',
              answer: question.answer || '',
              analysis: question.explanation || '',
              evaluate: question.evaluate || '考查学生对相关知识的理解和应用',
              repoId: parseInt(this.selectedRepoId) || 1,
              version: '人教版',
              knowledge: this.selectedKnowledgePoint || '未分类',
              chapter: null,
              options: this.formatOptions(question.options, quType),
              difficulty: parseFloat(question.difficulty) || 0.5,
              type: this.getQuestionTypeName(quType),
              level: parseInt(question.level) || 2
            };
          });

          try {
            const saveResponse = await saveOcrQuestions(questionsToSave);
            if (saveResponse.code === 1) {
              const newQuestions = questionsToSave.map((question, index) => ({
                id: saveResponse.data && saveResponse.data[index] ? saveResponse.data[index].id : Date.now() + Math.random(),
                content: question.content,
                answer: question.answer,
                knowledge: question.knowledge,
                analysis: question.analysis,
                quType: question.quType,
                chapter: question.chapter,
                point: question.point,
                createTime: question.createTime
              }));

              this.questionList = [...this.questionList, ...newQuestions];
              this.$nextTick(() => newQuestions.forEach(q => this.selectedQuestions.push(q.id)));
              this.$message.success(`OCR识别成功！已保存 ${newQuestions.length} 道题目到数据库并添加到题目列表`);
              this.ocrDialogVisible = false;
            } else {
              throw new Error(saveResponse.message || '保存失败');
            }
          } catch (saveError) {
            console.error('保存OCR题目到数据库失败:', saveError);
            this.$message.warning('OCR识别成功，但保存到数据库失败，题目已添加到列表但未保存');
            const newQuestions = questionsToSave.map(question => ({
              id: Date.now() + Math.random(),
              content: question.content,
              answer: question.answer,
              knowledge: question.knowledge,
              analysis: question.analysis,
              quType: question.quType,
              chapter: question.chapter,
              point: question.point,
              createTime: question.createTime
            }));
            this.questionList = [...this.questionList, ...newQuestions];
            this.$nextTick(() => newQuestions.forEach(q => this.selectedQuestions.push(q.id)));
            this.ocrDialogVisible = false;
          }
        })
        .catch((error) => {
          loadingInstance.close();
          console.error('OCR识别失败：', error);
          this.$message.error('OCR识别失败：' + (error.message || '未知错误'));
        });
    },

    // 处理OCR对话框关闭
    handleOcrDialogClose(done) {
      this.fileList = [];
      done();
    },

    showInputDialog() {
      this.inputDialogVisible = true
      // 重置表单
      this.inputQuestionForm = {
        quType: '',
        content: '',
        answer: '',
        knowledge: '',
        analysis: '',
        evaluate: '',
        options: '',
        difficulty: 0.5,
        level: 2
      }
    },

    async handleInputQuestion() {
      // 验证必填字段
      if (!this.inputQuestionForm.quType) {
        this.$message.warning('请选择题目类型')
        return
      }
      if (!this.inputQuestionForm.content) {
        this.$message.warning('请输入题目内容')
        return
      }

      // 准备保存到数据库的数据
      const questionToSave = {
        quType: this.inputQuestionForm.quType,
        content: this.inputQuestionForm.content,
        answer: this.inputQuestionForm.answer || '',
        analysis: this.inputQuestionForm.analysis || '',
        evaluate: this.inputQuestionForm.evaluate || '考查学生对相关知识的理解和应用',
        repoId: parseInt(this.selectedRepoId) || 1, // 确保是Integer类型
        version: '人教版',
        knowledge: this.selectedKnowledgePoint || '未分类',
        chapter: null, // 章节字段设为null
        options: this.formatOptions(this.inputQuestionForm.options, this.inputQuestionForm.quType), // 使用辅助方法处理选项格式
        difficulty: parseFloat(this.inputQuestionForm.difficulty) || 0.5, // 确保是BigDecimal类型
        type: this.getQuestionTypeName(this.inputQuestionForm.quType),
        level: parseInt(this.inputQuestionForm.level) || 2 // 确保是Integer类型
      };

      try {
        // 先保存到数据库
        const saveResponse = await saveOcrQuestions([
          questionToSave
        ]);

        if (saveResponse.code === 1) {
          console.log('手动输入题目已保存到数据库:', saveResponse);

          // 保存成功后，创建题目对象
          const newQuestion = {
            id: saveResponse.data && saveResponse.data[0] ? saveResponse.data[0].id : Date.now(),
            quType: questionToSave.quType,
            content: questionToSave.content,
            chapter: questionToSave.chapter,
            answer: questionToSave.answer,
            analysis: questionToSave.analysis,
            point: questionToSave.point,
            createTime: questionToSave.createTime
          };

          // 添加到左侧题目列表中
          this.questionList.push(newQuestion);

          // 自动选中新添加的题目
          this.$nextTick(() => {
            this.selectedQuestions.push(newQuestion.id);
          });

          this.$message.success('题目已保存到数据库并添加到题目列表！');
          this.inputDialogVisible = false;
        } else {
          throw new Error(saveResponse.message || '保存失败');
        }
      } catch (saveError) {
        console.error('保存手动输入题目到数据库失败:', saveError);
        this.$message.warning('保存到数据库失败，题目已添加到列表但未保存');

        // 即使保存失败，也添加到题目列表
        const newQuestion = {
          id: Date.now(),
          quType: questionToSave.quType,
          content: questionToSave.content,
          chapter: questionToSave.chapter,
          answer: questionToSave.answer,
          analysis: questionToSave.analysis,
          point: questionToSave.point,
          createTime: questionToSave.createTime
        };

        this.questionList.push(newQuestion);
        this.$nextTick(() => {
          this.selectedQuestions.push(newQuestion.id);
        });
        this.inputDialogVisible = false;
      }
    },

    // 获取作业统计信息
    async fetchHomeworkStats(homeworkId) {
      try {
        const response = await getHomeworkStats(homeworkId)
        if (response.code === 1) {
          this.homeworkStats = response.data
          return response.data
        } else {
          this.$message.warning(response.msg || '获取统计信息失败')
          return null
        }
      } catch (error) {
        console.error('获取作业统计信息失败:', error)
        this.$message.error('获取作业统计信息失败')
        return null
      }
    },

    // 显示自建作业对话框
    showImageHomeworkCreator() {
      this.imageHomeworkCreatorVisible = true
    },

    // 处理自建作业成功
    handleImageHomeworkCreated() {
      this.fetchHomeworkList() // 重新获取作业列表
    },

    // 打开批量上传对话框
    openBatchUpload(homework) {
      // 使用路由导航到BatchStudentUpload组件
      this.$router.push({
        name: 'BatchStudentUpload',
        params: { id: homework.id },
        query: { homeworkName: homework.name }
      });
    },

    // 获取班级学生列表
    async fetchStudentList(gradeId) {
      // 实际项目中应该调用API获取学生列表
      // 这里使用模拟数据
      this.studentSelectList = [
        { id: 1, name: 'student', username: 'student' },
        { id: 2, name: 'student1', username: 'student1' },
        { id: 3, name: 'student2', username: 'student2' },
        { id: 4, name: 'student3', username: 'student3' },
        { id: 5, name: 'student5', username: 'student5' },
        { id: 6, name: 'student13', username: 'student13' },
        { id: 7, name: 'student14', username: 'student14' }
      ];
    },

    // 处理文件变化
    handleBatchFileChange(file, fileList) {
      this.studentFileList = fileList;
    },

    // 处理文件删除
    handleBatchFileRemove(file, fileList) {
      this.studentFileList = fileList;
    },

    // 提交批量上传
    async submitBatchUpload() {
      if (this.studentFileList.length === 0) {
        this.$message.warning('请至少上传一个文件');
        return;
      }

      const loadingInstance = this.$loading({
        lock: true,
        text: '正在上传中...',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      try {
        // 模拟上传过程
        await new Promise(resolve => setTimeout(resolve, 2000));

        // 上传成功后的处理
        this.$message.success('批量上传成功');
        this.batchUploadVisible = false;

        // 刷新作业列表
        this.fetchHomeworkList();
      } catch (error) {
        console.error('批量上传失败', error);
        this.$message.error('批量上传失败，请重试');
      } finally {
        loadingInstance.close();
      }
    }
  }
};
</script>

<style scoped>
.action-column {
  white-space: nowrap;
}

/* 操作按钮样式 */
.edit-btn {
  color: #4a90e2;
  /* 蓝色 */
  margin-right: 10px;
  cursor: pointer;
}

.publish-btn {
  color: #42b983;
  /* 绿色 */
  margin-right: 10px;
  cursor: pointer;
}

.delete-btn {
  color: #db2828;
  /* 红色 */
  margin-right: 10px;
  cursor: pointer;
}

.batch-upload-btn {
  color: #ff9800;
  /* 橙色 */
  cursor: pointer;
}

/* 鼠标悬停效果 */
.edit-btn:hover,
.publish-btn:hover,
.delete-btn:hover,
.batch-upload-btn:hover {
  text-decoration: underline;
}

.app-container {
  padding: 20px;
}

.header-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.total-count {
  font-size: 1.2em;
  font-weight: 500;
}

.create-btn {
  padding: 8px 16px;
  background-color: #42b983;
  /* 绿色，可根据设计调整 */
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.homework-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
}

.homework-table th,
.homework-table td {
  padding: 12px 15px;
  border: 1px solid #e4e7ed;
  text-align: left;
}

.homework-table th {
  background-color: #f5f7fa;
  font-weight: 600;
  font-size: 0.95em;
}

.action-column {
  white-space: nowrap;
}

.view-btn {
  color: #42b983;
  cursor: pointer;
  margin-left: 10px;
  /* 可以在这里添加图标字体，比如：font-awesome的fa-eye */
}

/* 原有样式保持不变，新增加载状态样式（可根据Element UI调整） */
.el-loading-mask {
  z-index: 9999;
}

.homework-editor {
  height: 600px;
  display: flex;
  flex-direction: column;
}

.editor-container {
  display: flex;
  height: 100%;
  gap: 20px;
}

.editor-left {
  flex: 1;
  min-width: 350px;
  max-width: 50%;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 15px;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: visible;
}

.editor-right {
  flex: 1;
  min-width: 350px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 15px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.editor-left h3,
.editor-right h3 {
  margin-top: 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #e4e7ed;
}

.question-list {
  flex: 1;
  overflow-y: auto;
  overflow-x: visible;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #909399;
}

.empty-state p {
  margin: 5px 0;
}

.preview-area {
  flex: 1;
  overflow-y: auto;
  background-color: #f5f7fa;
  border-radius: 4px;
  padding: 15px;
}

/* 确保弹窗内容可以滚动 */
:deep(.el-dialog__body) {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}

.knowledge-select {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  display: flex;
  align-items: center;
}

.question-items {
  padding: 10px;
}

.question-item {
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  transition: all 0.3s;
}

.question-item:hover {
  background-color: #f5f7fa;
}

.question-content {
  margin-left: 8px;
}

.question-title {
  font-weight: 500;
  margin-bottom: 5px;
}

.question-info {
  font-size: 12px;
  color: #909399;
}

.question-info span {
  margin-right: 15px;
}

.question-actions {
  padding: 10px;
  border-top: 1px solid #e4e7ed;
  text-align: center;
  background-color: #fff;
  position: sticky;
  bottom: 0;
}

/* 确保选择器和按钮在同一行 */
.el-select {
  margin-right: 10px;
}

.preview-questions {
  padding: 15px;
}

.preview-question-item {
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  margin-bottom: 15px;
  background-color: #fff;
}

.question-header {
  padding: 10px 15px;
  background-color: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.question-number {
  font-weight: 500;
  color: #409EFF;
}

.question-body {
  padding: 15px;
}

.preview-question-item .question-content {
  margin-bottom: 10px;
  line-height: 1.6;
}

.preview-question-item .question-info {
  font-size: 12px;
  color: #909399;
}

.preview-question-item .question-info span {
  margin-right: 15px;
}

.delete-btn {
  color: #F56C6C;
}

.delete-btn:hover {
  color: #f78989;
}

.class-select-container {
  padding: 20px;
}

.student-name {
  color: #409EFF;
  cursor: pointer;
}

.student-name:hover {
  text-decoration: underline;
}

.student-info {
  margin-bottom: 20px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.student-info h3 {
  margin: 0;
  color: #303133;
}

.correction-dialog-body-beauty {
  display: flex;
  gap: 40px;
  align-items: flex-start;
  min-height: 400px;
  max-height: 70vh;
  overflow-x: auto;
  overflow-y: auto;
  background: #f7f8fa;
  border-radius: 12px;
  padding: 24px 0;
}
.correction-image-beauty {
  flex: 0 0 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  min-height: 400px;
  max-width: 420px;
  padding: 16px 8px 8px 8px;
  position: relative;
}
.no-image {
  color: #aaa;
  font-size: 16px;
  margin-top: 100px;
}
.zoom-tip {
  margin-top: 8px;
  color: #888;
  font-size: 13px;
  text-align: center;
}
.correction-table-beauty {
  flex: 1 1 0;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  padding: 16px;
  min-width: 350px;
  overflow: auto;
}
.student-info {
  margin-bottom: 20px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
}
.student-info h3 {
  margin: 0;
  color: #303133;
}

.upload-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.question-type-select {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.question-type-select .label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 5px;
}

.el-radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.el-radio {
  margin-right: 0;
}

.image-navigation {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin-top: 15px;
  padding: 10px;
  background: #f5f7fa;
  border-radius: 8px;
}

.image-counter {
  font-size: 14px;
  color: #606266;
  min-width: 60px;
  text-align: center;
}

.stats-cards {
  margin-bottom: 20px;
}

.stats-card {
  height: 120px;
}

.stats-card-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.stats-card-title {
  font-size: 16px;
  color: #606266;
  margin-bottom: 10px;
}

.stats-card-value {
  font-size: 28px;
  font-weight: bold;
  color: #409EFF;
}

.score-distribution-mini {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.distribution-item-mini {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  font-size: 14px;
}

.range-label-mini {
  color: #606266;
}

.count-value {
  font-weight: bold;
}

.buttons-group {
  display: flex;
  gap: 10px;
}

.image-create-btn {
  padding: 8px 16px;
  background-color: #409EFF;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.image-create-btn:hover {
  background-color: #66b1ff;
}

/* 错题本复选框样式 */
.el-checkbox {
  font-size: 14px;
  color: #606266;
}

.el-checkbox__label {
  color: #606266;
}

/* 班级标签样式 */
.class-tags-container {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 8px;
  border: 1px solid #e4e7ed;
}

.class-tags-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.tags-label {
  font-weight: 500;
  color: #606266;
  margin-right: 15px;
  margin-bottom: 10px;
}

.class-tag {
  transition: all 0.3s ease;
  border-radius: 20px;
  padding: 8px 16px;
  font-size: 14px;
}

.class-tag:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.submission-count {
  font-weight: bold;
  margin-left: 5px;
}

/* 数学公式样式 */
.question-title {
  line-height: 1.6;
}

.question-title .katex {
  font-size: 1em;
  display: inline;
}

.question-title .katex-display {
  margin: 0.5em 0;
  text-align: center;
  display: block;
}

/* 确保数学公式在题目内容中正确显示 */
.question-content .katex {
  font-size: inherit;
  display: inline;
}

.question-content .katex-display {
  margin: 0.3em 0;
  text-align: left;
  display: block;
}

/* 确保KaTeX元素可见 */
.katex {
  font-family: KaTeX_Main, "Times New Roman", serif;
  font-size: 1em;
  line-height: 1.2;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.katex .base {
  display: inline-block;
}

.katex .mord {
  display: inline-block;
}

.katex .mrel {
  display: inline-block;
}

.katex .mbin {
  display: inline-block;
}

.katex .mopen, .katex .mclose {
  display: inline-block;
}

/* 确保题目内容不被截断 */
.question-title {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  max-width: 100%;
}

.question-content {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  max-width: 100%;
}

/* 确保题目列表项不被截断 */
.question-item {
  width: 100%;
  overflow: visible;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.question-item .question-content {
  width: 100%;
  overflow: visible;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

/* 确保el-checkbox不会截断内容 */
.question-item .el-checkbox {
  width: 100%;
  display: block;
}

.question-item .el-checkbox__label {
  width: 100%;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>
